module.exports = __webpack_public_path__ + "media/stylesheets/images/martech/ltv_open_rate-71c8c0d00c242f55a21d864709aa0d5b.svg";